// React
import React, { Children, isValidElement, cloneElement } from "react";
// Framework
import { DragOverlay } from "@dnd-kit/core";
import { makeStyles } from "ui/components";
import { Table, TableBody } from "@material-ui/core";
import { restrictToParentElement } from "@dnd-kit/modifiers";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles((theme) => ({
  table: {
    width: "100%",
    height: "100%",
  },
}));

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const TableDragOverlay = ({ activeId, draggedRow }) => {
  // Styles
  const classes = useStyles();
  // Render
  return (
    <DragOverlay modifiers={[restrictToParentElement]}>
      <Table className={classes.table}>
        <TableBody>
          {Children.map(
            draggedRow,
            (child, index) =>
              isValidElement(child) &&
              cloneElement(child, {
                draggable: true,
                __renderProps: { index, dragged: true },
              })
          )}
        </TableBody>
      </Table>
    </DragOverlay>
  );
};

export default TableDragOverlay;
